import { Moment } from 'moment';
import { createContext, Dispatch, SetStateAction } from 'react';

// --- Sub-Interfaces for Type Safety ---

export interface FeeData {
    fee?: number | string;
    discountValue?: number;
    startDate?: string | Moment | Date;
    expiryDate?: string | Moment | Date | null;
    feeType?: number;
}

export interface ClientData {
    isLockCodeChecked: boolean;
    clientDisplayName: string;
    blockingCode: string | number;
    grund: string;
    refNumber: string | number;
    shippingMethod: string;
}

export interface PortfolioDetail {
    title?: string;
    productId?: number;
    overview?: {
        product: string;
        strategy: string;
    };
    customAttributes?: {
        CreateDate?: string;
        [key: string]: any;
    };
    [key: string]: any;
}

export interface ApplicationDetails {
    investmentDescription?: {
        fees?: FeeData[];
    };
}

// --- Main Context Type ---

export type SinglePortfolioType = {
    // Basic Info
    navigation: any[]; // Or specific NavigationItem type
    portfolioName: string;
    productName: string | null;
    productNameRisk?: string;
    selectedProductSettings: Record<string, any>;

    // Data Objects
    portfolioDetail?: PortfolioDetail;
    portfolioDetailRaw?: any;
    saldo?: number;

    // Product & Strategy Flags
    isPortfolioChangeable?: boolean;
    isMigratedPortfolio?: boolean;
    migrationDate?: string | null;
    hasAccessToChangeStrategy?: boolean;
    is3B?: boolean;
    is3ap?: boolean;
    isVBOrVBP?: boolean;
    isPk?: boolean;
    isAzp?: boolean;
    isAzpAlt?: boolean;
    isZivAzp?: boolean;
    isZic?: boolean;
    isZifd?: boolean;
    isZiv?: boolean;
    productType?: string;

    // Client/Owner Data (Added for the new Provider logic)
    mainClientData?: ClientData;
    jointClientData?: ClientData;
    clientProfile?: any;

    // Strategy & Hook Data (Spread from useStrategy)
    strategyName?: string;
    modelPortfolio?: {
        Id: string | number;
        Attributes: string;
        [key: string]: any;
    };
    allocations?: any[];
    rebalancingOptions?: any;
    rebalancing?: boolean;

    // Application & Fees
    lastApplicationDetails?: ApplicationDetails;
    investmentAppId?: string | number | null;
    fees?: FeeData[];
    setFees?: Dispatch<SetStateAction<FeeData[]>>;

    // State Flags
    isLoading?: boolean;
    error?: Error | string | null;
    isPortfolioOnReadOnly?: boolean;
    riskCategories: {text: string}[];

    // Methods
    getSelectStrategy?: (id?: string | number) => number;
    handleRebalanceChange?: (val: any) => void;
    getFormattedXAxisFormat?: (val: any) => string;
};

const initialContext: SinglePortfolioType = {
    navigation: [],
    portfolioName: '',
    productName: '',
    selectedProductSettings: {},
    isLoading: false,
    riskCategories: [],
};

const SinglePortfolioContext = createContext<SinglePortfolioType>(initialContext);

export default SinglePortfolioContext;
